// extracted by mini-css-extract-plugin
export default {"pagesContainer":"TermsOfUse_pagesContainer__hDPJU","guidelinesCell":"TermsOfUse_guidelinesCell__IYWbi"};